// トークチャンネル最大個数
export const TALK_ROOM_GROUP_MAX = 50;

// トークDM最大個数
// https://fincs.backlog.com/view/FINCS-3851
export const TALK_ROOM_DM_MAX = 10000;

// トークDM初期未読チェック個数
// https://fincs.backlog.com/view/FINCS-4187
export const TALK_ROOM_DM_INIT_UNREAD_MAX = 100;

// トークDMページ内個数
// https://fincs.backlog.com/view/FINCS-4083
export const TALK_ROOM_DM_PER_PAGE = 20;

// トークチャンネル+DM+アーカイブ最大個数
// https://fincs.backlog.com/view/FINCS-3229
export const TALK_ROOM_TOTAL_MAX = TALK_ROOM_DM_MAX + 2500;

// トークアーカイブ最大個数
export const TALK_ROOM_ARCHIVE_MAX = TALK_ROOM_TOTAL_MAX - TALK_ROOM_GROUP_MAX - TALK_ROOM_DM_MAX;

// トークルームの日付表示フォーマット
export const TALK_DATE_FORMAT = "M/d(E)";

// トーク入力最大文字数
export const TALK_INPUT_TEXT_MAX = 5000;

// トーク返信最大文字数
export const TALK_REPLY_TEXT_MAX = 270;

// トーク ID 最小値
export const TALK_ID_MINIMUM = "1";

// トーク ID 無限大
export const TALK_ID_INFINITY = "1000000000"; // 到達し得ない値として 10 億を設定

// トークスレッド ID 未設定値
export const TALK_THREAD_ID_NONE = "0";

// トークスレッドタブ内子トーク最大個数
export const TALK_THREAD_TAB_CHILD_DISP_MAX = 2;

// トークスレッドタブクエリ最大数
// 他のユーザーデータより重いので数を絞る
export const TALK_THREAD_TAB_QUERY_MAX = 5;

// トークユーザーデータクエリ最大数
export const TALK_USER_DATA_QUERY_MAX = 10;

// トークユーザーデータ項目テキスト最大文字数
export const TALK_USER_DATA_ITEM_TEXT_MAX = 50;

// トークブックマークのルームごと最大個数
export const TALK_BOOKMARK_PER_ROOM_MAX = 30;

// トークメンション用プレースホルダー
export const TALK_MENTION_PLACEHOLDER = "<mention>";

// トークメンション候補最大数
export const TALK_MENTION_USERS_MAX = 20;

// トーク検索期間（日数）
export const TALK_SEARCH_PERIOD_DAYS = 365;

// トーク検索ボックス高さ
export const TALK_SEARCH_BOX_HEIGHT = 56;

// トーク未読ライン高さ
export const TALK_UNREAD_LINE_HEIGHT = 32;

// トーク更新デバウンス時間（ミリ秒）
export const TALK_UPDATE_DEBOUNCE_TIME = 2000;

// トーク開始日付・全データ（サービス開始前日付で全データを対象とする）
export const TALK_DATE_FROM_ALL = new Date("2023-01-01");

// トーク開始日付・データなし（到達し得ない未来日付で全データを対象外とする）
export const TALK_DATE_FROM_NONE = new Date("2099-01-01");

// トーク画像ファイルサイズ上限
export const TALK_FILE_SIZE_MB_IMAGE = 20; // 20MB

// トーク動画ファイルサイズ上限
export const TALK_FILE_SIZE_MB_MOVIE = 100; // 100MB

// トークPDFファイルサイズ上限
export const TALK_FILE_SIZE_MB_PDF = 20; // 20MB
